module.exports = __webpack_public_path__ + "static/media/heart.f2a6a2a9.svg";